module.exports = __webpack_public_path__ + "img/Hrvaška.1139ab20.png";